module.exports = __webpack_public_path__ + "static/media/thumbnail.17848ceb.jpg";